import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiLock, FiHome } from 'react-icons/fi';
import './Errors.scss';

const Unauthorized = () => {
  return (
    <div className="error-page">
      <motion.div
        className="error-content"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="error-icon">
          <FiLock />
        </div>
        <h1>Unauthorized Access</h1>
        <p>You don't have permission to access this resource.</p>
        <div className="error-actions">
          <Link to="/dashboard" className="btn btn-primary">
            <FiHome /> Go to Dashboard
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default Unauthorized;